import store from '@/store'

export const provideCurrentJWT = (): string => {
    return store.getters?.currentRole?.jwt || ''
}
